import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getEmployeePerformance = async (params: any) => {
  const { data: response } = await axios.get(endpoints.EMPLOYEE_PERFORMANCE, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getEmployeePerformanceById = async (id: number) => {
  const { data: response } = await axios.get(
    endpoints.DETAIL_EMPLOYEE_PERFORMANCE(id),
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const createEmployeePerformance = async (params: any) => {
  const { data: response } = await axios.post(
    endpoints.EMPLOYEE_PERFORMANCE,
    params,
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const updateEmployeePerformance = async (params: any) => {
  const { data: response } = await axios.patch(
    endpoints.DETAIL_EMPLOYEE_PERFORMANCE(params.id),
    params.data,
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const deleteEmployeePerformance = async (id: number) => {
  const { data: response } = await axios.delete(
    endpoints.DETAIL_EMPLOYEE_PERFORMANCE(id),
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const exportEmployeePerformance = async (params: {
  month: number;
  year: number;
}) => {
  const response = await axios.get(endpoints.EMPLOYEE_PERFORMANCE_EXPORT, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "arraybuffer",
    params,
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  fileDownload(blob, `employee_performance_${params.month}_${params.year}.xlsx`);
};

const exportEmployeePerformanceSummary = async (params: {
  month: number;
  year: number;
}) => {
  const response = await axios.get(endpoints.EMPLOYEE_PERFORMANCE_EXPORT_SUMMARY, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "arraybuffer",
    params,
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  fileDownload(
    blob,
    `employee_performance_summary_${params.month}_${params.year}.xlsx`
  );
};

const uploadBulkEmployeePerformance = async (params: FormData) => {
  const { data: response } = await axios.post(
    endpoints.EMPLOYEE_PERFORMANCE_BULK,
    params,
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const employeePerformance = {
  getEmployeePerformance,
  getEmployeePerformanceById,
  createEmployeePerformance,
  updateEmployeePerformance,
  deleteEmployeePerformance,
  exportEmployeePerformance,
  exportEmployeePerformanceSummary,
  uploadBulkEmployeePerformance,
};

export default employeePerformance;
